import { useTranslation } from 'react-i18next';
import { profile } from '../../content/profile.js';

export function Stats() {
  const { t } = useTranslation(['stats']);

  return (
    <section className="stats band-forest" aria-label={t('stats:throughput')}>
      {profile.stats.map((stat) => (
        <div key={stat.id}>
          {/* The figures stay Latin in every locale; isolate them so the bidi
              algorithm cannot reorder "1M/s" under RTL. */}
          <div className="stats__value" dir="ltr">
            <bdi>{stat.value}</bdi>
          </div>
          <div className="stats__label">{t(`stats:${stat.id}`)}</div>
        </div>
      ))}
    </section>
  );
}
